import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '../../client';
import { logout } from './userReducer/api';
import { REQUEST_STATUS } from '../../constants';

const checkSideMenu = () => {
  return localStorage.getItem('IsSideMenuPinned');
};

const setIsSideMenuPinned = (val) => {
  localStorage.setItem('IsSideMenuPinned', val);
};

const checkAuthorizationExpiresTimeoutLocally = () => {
  return localStorage.getItem('authorizationExpiresTimeout');
};

const setAuthorizationExpiresTimeoutLocally = (val) => {
  localStorage.setItem('authorizationExpiresTimeout', val);
};

const clearAuthorizationExpiresTimeoutLocally = () => {
  localStorage.removeItem('authorizationExpiresTimeout');
};

export const fetchDisabledFeatures = createAsyncThunk(
  'disabledfeatures/fetchDisabledfeatures',
  async () => {
    const res = await client.get(`/system/disabledfeatures`);
    return res;
  },
);

export const appSettingsSlice = createSlice({
  name: 'appSettings',
  initialState: {
    isSideMenuPinned: true,
    disabledFeatures: [],
    status: REQUEST_STATUS.idle,
    error: null,

    isTabActive: true,

    // auto-logout time
    authorizationExpiresTimeout: null,
    isScreenCanBeActive: true,
    isAutoLogoutDialogOpen: false,

    //screenSize
    screenHeight: 1000,
    screenWidth: 600,

    // navigation scroll position
    navigationScrollPosition: 0,
  },
  reducers: {
    setScreenSize: (state, action) => {
      state.screenHeight = action.payload.height;
      state.screenWidth = action.payload.width;
    },
    getAndSetIsSideMenuPinned: (state) => {
      if (checkSideMenu() === 'false') {
        state.isSideMenuPinned = false;
      }
    },
    checkAuthorizationExpiresTimeout: (state) => {
      state.authorizationExpiresTimeout = checkAuthorizationExpiresTimeoutLocally();
    },
    changeIsTabActive: (state, action) => {
      state.isTabActive = action.payload;
    },
    changeIsScreenCanBeActive: (state, action) => {
      state.isScreenCanBeActive = action.payload;
    },
    setAutoLogoutDialogOpen: (state, action) => {
      state.isAutoLogoutDialogOpen = action.payload;
    },
    setAuthorizationExpiresTimeout: (state, action) => {
      if (action.payload) {
        if (process.env.REACT_APP_ENV !== 'production') {
          console.log('--------------------NEW Expires Date/Time: ', action.payload);
        }
        // const newTokenTime = Date.now() + action.payload * 60 * 1000;
        const time = process.env.REACT_APP_ENV === 'production' ? 30 : 20;
        const newTokenTime = Date.now() + time * 60 * 1000;
        state.authorizationExpiresTimeout = newTokenTime;
        setAuthorizationExpiresTimeoutLocally(newTokenTime);
      }
    },
    toggleIsSideMenuPinned: (state) => {
      const newIsSideMenuPinned = !state.isSideMenuPinned;

      setIsSideMenuPinned(newIsSideMenuPinned);
      state.isSideMenuPinned = newIsSideMenuPinned;
    },
    removeAuthorizationExpiresTimeout: (state) => {
      clearAuthorizationExpiresTimeoutLocally();
      state.authorizationExpiresTimeout = null;
    },
    setNavigationScrollPosition: (state, action) => {
      state.navigationScrollPosition = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(logout.fulfilled, (state) => {
        state.authorizationExpiresTimeout = null;
      })
      .addCase(fetchDisabledFeatures.pending, (state) => {
        state.status = REQUEST_STATUS.loading;
      })
      .addCase(fetchDisabledFeatures.fulfilled, (state, action) => {
        if (action.payload.ok) {
          state.status = REQUEST_STATUS.succeeded;
          state.disabledFeatures = action.payload.data.data;
        } else {
          state.status = REQUEST_STATUS.failed;
          state.error = action?.payload?.error?.message;
        }
      });
  },
});

export const {
  setScreenSize,
  getAndSetIsSideMenuPinned,
  toggleIsSideMenuPinned,
  checkAuthorizationExpiresTimeout,
  setAuthorizationExpiresTimeout,
  changeIsTabActive,
  removeAuthorizationExpiresTimeout,
  changeIsScreenCanBeActive,
  setAutoLogoutDialogOpen,
  setNavigationScrollPosition,
} = appSettingsSlice.actions;

export default appSettingsSlice.reducer;
